
class exports.BaseOutput

    constructor: (parent, dialog, width = 'auto', dtOpts = {}, auxOpts = {}) ->
        @parent         = parent
        @dialog         = dialog
        @width          = width
        @tables         = []
        @auxTables      = []

        @dtOptions      =
            sScrollY: '200px'
            bDestroy: true
            bPaginate: false
            bFilter: false
            bInfo: false
            bSort: false

        @dtAuxOptions   =
            bDestroy: true
            bPaginate: false
            bFilter: false
            bInfo: false
            bSort: false

        @dtOptions = $.extend @dtOptions, dtOpts
        @dtAuxOptions = $.extend @dtAuxOptions, auxOpts



    buildTable: () ->
        # This class will only be on tab-content if NonTableOutput was the previous output
        @dialog.dialog.find('.tab-content').removeClass('overflow-hidden')
        @dialog.dialog.find('.tab-content').width(@width)

        if @dialog.dialog.find('.createDT.scrollDT').length > 0
            @tables = @dialog.dialog.find('.createDT.scrollDT').find('.table')
            $(table).dataTable @dtOptions for table in @tables
        else
            @tables = []

        if @dialog.dialog.find('.createDT').not('scrollDT').length > 0
            @auxTables = @dialog.dialog.find('.createDT').not('.scrollDT').find('.table')
            $(table).dataTable @dtAuxOptions for table in @auxTables
        else
            @auxTables = []


        @dialog.resize()

    destroy: () ->
        @dialog.dialog.find('.tab-content').width('auto')

    resizeTable: () ->
        for table in @tables
            table = $(table)
            dtsb_parent = table.closest('.tab-content')
            scrollDT = table.closest('.scrollDT')

            if @tables.length > 1
                h = dtsb_parent.height()
                ns = ( (h / @tables.length) - (5 * @tables.length) )

                scrollDT.resizr({ new_size: ns })
            else
                scrollDT.resizr()

            scrollDT.find('.dataTables_wrapper').resizr()
            scrollDT.find('.dataTables_scroll').resizr()
            scrollDT.find('.dataTables_scrollBody').resizr()

            table = table.dataTable()
            if table?.fnSettings()?
                size = scrollDT.find('.dataTables_scrollBody').resizr('resize') - 20
                table.fnSettings().oScroll.sY = "#{size}px"
                table.fnAdjustColumnSizing(false)
